import React from 'react';
import InputField from '../input/inputField';

interface Props {
  email: string;
  password: string;
  confirmPassword: string;
  onEmailChange: (email: string) => unknown;
  onPasswordChange: (password: string) => unknown;
  onConfirmPasswordChange: (confirmPassword: string) => unknown;
  isUpdating?: boolean;
}
export const ParentAccountDetails = ({
  email,
  password,
  confirmPassword,
  onEmailChange,
  onPasswordChange,
  onConfirmPasswordChange,
  isUpdating = false,
}: Props) => {
  const passwordLabel = isUpdating ? 'New password' : 'Password *';
  return (
    <div className="grid grid-cols-1 gap-x-8 w-full md:w-72 lg:w-72">
      <InputField
        value={email}
        setValue={(email) => onEmailChange(email)}
        label="Email *"
        isRequiredFocusonValidation
        name="register-parents-email"
      />
      <InputField
        value={password}
        setValue={(password) => onPasswordChange(password)}
        label={passwordLabel}
        isPassword
        isRequiredFocusonValidation
        name="register-parents-password"
      />
      <InputField
        value={confirmPassword}
        setValue={(confirmPassword) => onConfirmPasswordChange(confirmPassword)}
        label="Confirm password *"
        isPassword
        isRequiredFocusonValidation
        name="register-parents-confirm-password"
      />
    </div>
  );
};
